/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, {
  ChangeEvent,
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import { FormHandles } from '@unform/core';
import ReactQuill from 'react-quill';
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from 'react-grid-dnd';
import { HiPlus } from 'react-icons/hi';
import { BsChatRightText } from 'react-icons/bs';
import { IoIosShareAlt, IoMdClose } from 'react-icons/io';
import Swal from 'sweetalert2';
import { AxiosResponse } from 'axios';
import { Form } from '@unform/web';
import { MdUpload } from 'react-icons/md';

import Toast from '~/utils/toast';
import api from '~/services/api';

import Input from '~/components/Input';
import InputCheckbox from '~/components/InputCheckbox';
import { KrClose, KrEdit, KrTrash } from '~/components/KoroIcons';
import Loading from '~/components/Loading';
import { Container, Modal } from './styles';

interface IFileKit {
  id?: number;
  name: string;
  url: string;
  size?: number;
  file?: File;
}

export interface ICardKit {
  id: number;
  kit_id?: number;
  description: string;
  link: string;
  file: IFileKit;
}

interface IFormDataKit {
  id: number;
  description: string;
  link: string;
  file: IFileKit;
}

interface ISize {
  id: number;
  quantity_id?: number;
  size: string;
  quantity?: string;
  qtdSold?: number;
  active: boolean;
}

interface IFormData {
  qty14Child: string;
  qty12Child: string;
  qty10Child: string;
  qty8Child: string;
  qty6Child: string;
  qty4Child: string;
  qty2Child: string;
  qtyPp: string;
  qtyP: string;
  qtyM: string;
  qtyG: string;
  qtyGg: string;
  qtyXg: string;
  qtyXxg: string;

  qtyPpBaby: string;
  qtyPBaby: string;
  qtyMBaby: string;
  qtyGBaby: string;
  qtyGgBaby: string;
  qtyXgBaby: string;
  qtyXxgBaby: string;
}

interface IKits {
  initialData?: {
    has_size_variation: boolean;
    kitId?: number;
    description?: string;
    stock_control?: boolean;
    kit_enabled?: boolean;
    kits?: ICardKit[];
    sizes?: ISize[];
  };
  event_id: number;
  sold?: boolean;
  onChange(
    kits: ICardKit[],
    sizes: ISize[],
    description: string,
    stockControl: boolean,
    hasSizeVariation: boolean,
    kitEnabled: boolean
  ): void;
  onKitErrorChange?: (hasError: boolean) => void;
}

export interface IKitsHandle {
  submit: () => void;
}

const Kits: ForwardRefRenderFunction<IKitsHandle, IKits> = (
  { initialData, event_id, sold, onChange },
  ref
) => {
  const formRef = useRef<FormHandles>(null);
  const productFormRef = useRef<FormHandles>(null);
  const [description, setDescription] = useState('');
  const [checkVariationSize, setCheckVariationSize] = useState(false);
  const [checkStockControl, setCheckStockControl] = useState(true);
  const [cardsKit, setCardsKit] = useState<ICardKit[]>([]);
  const [cardKitSelected, setCardKitSelected] = useState<IFormDataKit | null>(
    null
  );
  const [oldFileKit, setOldFileKit] = useState({} as IFileKit);
  const [filesKit, setFilesKit] = useState<File[]>([]);
  const [show, setShow] = useState(false);
  const [sizesKit, setSizesKit] = useState<ISize[]>([
    { id: 1, size: 'PP', quantity: '0', qtdSold: 0, active: false },
    { id: 2, size: 'P', quantity: '0', qtdSold: 0, active: false },
    { id: 3, size: 'M', quantity: '0', qtdSold: 0, active: false },
    { id: 4, size: 'G', quantity: '0', qtdSold: 0, active: false },
    { id: 5, size: 'GG', quantity: '0', qtdSold: 0, active: false },
    { id: 6, size: 'XG', quantity: '0', qtdSold: 0, active: false },
    { id: 7, size: 'XXG', quantity: '0', qtdSold: 0, active: false },
    { id: 8, size: 'PP_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 9, size: 'P_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 10, size: 'M_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 11, size: 'G_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 12, size: 'GG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 13, size: 'XG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 14, size: 'XXG_BABY', quantity: '0', qtdSold: 0, active: false },
    { id: 15, size: '2', quantity: '0', qtdSold: 0, active: false },
    { id: 16, size: '4', quantity: '0', qtdSold: 0, active: false },
    { id: 17, size: '6', quantity: '0', qtdSold: 0, active: false },
    { id: 18, size: '8', quantity: '0', qtdSold: 0, active: false },
    { id: 19, size: '10', quantity: '0', qtdSold: 0, active: false },
    { id: 20, size: '12', quantity: '0', qtdSold: 0, active: false },
    { id: 21, size: '14', quantity: '0', qtdSold: 0, active: false },
  ]);
  const [, setOldSizesKit] = useState<ISize[]>([
    { id: new Date().getTime() + 1, size: 'PP', quantity: '0', active: false },
    { id: new Date().getTime() + 2, size: 'P', quantity: '0', active: false },
    { id: new Date().getTime() + 3, size: 'M', quantity: '0', active: false },
    { id: new Date().getTime() + 4, size: 'G', quantity: '0', active: false },
    { id: new Date().getTime() + 5, size: 'GG', quantity: '0', active: false },
    { id: new Date().getTime() + 6, size: 'XG', quantity: '0', active: false },
    { id: new Date().getTime() + 7, size: 'XXG', quantity: '0', active: false },
    {
      id: new Date().getTime() + 8,
      size: 'PP_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 9,
      size: 'P_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 10,
      size: 'M_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 11,
      size: 'G_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 12,
      size: 'GG_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 13,
      size: 'XG_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 14,
      size: 'XXG_BABY',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 15,
      size: '2',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 16,
      size: '4',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 17,
      size: '6',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 18,
      size: '8',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 19,
      size: '10',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 20,
      size: '12',
      quantity: '0',
      active: false,
    },
    {
      id: new Date().getTime() + 21,
      size: '14',
      quantity: '0',
      active: false,
    },
  ]);
  const [qtySizeError] = useState('');
  const [kitId, setKitId] = useState<number | undefined>(undefined);
  const [oldCardsKit, setOldCardsKit] = useState<ICardKit[]>([]);
  const [, setFilesColor] = useState<File[]>([]);
  const [initialFormData, setInitialFormData] = useState({} as IFormData);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Carregando...');
  const [errorDescri, setErrorDescri] = useState(false);
  const checksInitialized = useRef(false);
  const hasChecksInitialized = useRef(false);
  const [checkPp, setCheckPp] = useState(false);
  const [checkP, setCheckP] = useState(false);
  const [checkM, setCheckM] = useState(false);
  const [checkG, setCheckG] = useState(false);
  const [checkGg, setCheckGg] = useState(false);
  const [checkXg, setCheckXg] = useState(false);
  const [checkXxg, setCheckXxg] = useState(false);
  const [checkPpBaby, setCheckPpBaby] = useState(false);
  const [checkPBaby, setCheckPBaby] = useState(false);
  const [checkMBaby, setCheckMBaby] = useState(false);
  const [checkGBaby, setCheckGBaby] = useState(false);
  const [checkGgBaby, setCheckGgBaby] = useState(false);
  const [checkXgBaby, setCheckXgBaby] = useState(false);
  const [checkXxgBaby, setCheckXxgBaby] = useState(false);
  const [check2Child, setCheck2Child] = useState(false);
  const [check4Child, setCheck4Child] = useState(false);
  const [check6Child, setCheck6Child] = useState(false);
  const [check8Child, setCheck8Child] = useState(false);
  const [check10Child, setCheck10Child] = useState(false);
  const [check12Child, setCheck12Child] = useState(false);
  const [check14Child, setCheck14Child] = useState(false);
  const [valuePp, setValuePp] = useState(-1);
  const [valueP, setValueP] = useState(-1);
  const [valueM, setValueM] = useState(-1);
  const [valueG, setValueG] = useState(-1);
  const [valueGg, setValueGg] = useState(-1);
  const [valueXg, setValueXg] = useState(-1);
  const [valueXxg, setValueXxg] = useState(-1);
  const [valuePpBaby, setValuePpBaby] = useState(-1);
  const [valuePBaby, setValuePBaby] = useState(-1);
  const [valueMBaby, setValueMBaby] = useState(-1);
  const [valueGBaby, setValueGBaby] = useState(-1);
  const [valueGgBaby, setValueGgBaby] = useState(-1);
  const [valueXgBaby, setValueXgBaby] = useState(-1);
  const [valueXxgBaby, setValueXxgBaby] = useState(-1);
  const [value2Child, setValue2Child] = useState(-1);
  const [value4Child, setValue4Child] = useState(-1);
  const [value6Child, setValue6Child] = useState(-1);
  const [value8Child, setValue8Child] = useState(-1);
  const [value10Child, setValue10Child] = useState(-1);
  const [value12Child, setValue12Child] = useState(-1);
  const [value14Child, setValue14Child] = useState(-1);
  const [checkKitEnabled, setCheckKitEnabled] = useState(true);

  // subir

  useEffect(() => {
    if (!initialData) {
      checksInitialized.current = true;
      return;
    }

    if (initialData.kitId) {
      setKitId(initialData.kitId);
    }

    if (initialData.kit_enabled !== undefined) {
      setCheckKitEnabled(initialData.kit_enabled);
    }

    if (initialData.description) {
      setDescription(initialData.description);
    }

    if (initialData.kits) {
      setCardsKit(initialData.kits);
      setOldCardsKit(JSON.parse(JSON.stringify(initialData.kits)));
    }

    if (initialData.sizes) {
      const formData = {} as IFormData;
      const sizesZero = initialData.sizes.every(
        (size) => size.quantity === '0'
      );
      if (!sizesZero) {
        for (const size of initialData.sizes) {
          if (size.size === 'PP') {
            formData.qtyPp = size.quantity || '';
          }
          if (size.size === 'P') {
            formData.qtyP = size.quantity || '';
          }
          if (size.size === 'M') {
            formData.qtyM = size.quantity || '';
          }
          if (size.size === 'G') {
            formData.qtyG = size.quantity || '';
          }
          if (size.size === 'GG') {
            formData.qtyGg = size.quantity || '';
          }
          if (size.size === 'XG') {
            formData.qtyXg = size.quantity || '';
          }
          if (size.size === 'XXG') {
            formData.qtyXxg = size.quantity || '';
          }

          if (size.size === 'PP_BABY') {
            formData.qtyPpBaby = size.quantity || '';
          }
          if (size.size === 'P_BABY') {
            formData.qtyPBaby = size.quantity || '';
          }
          if (size.size === 'M_BABY') {
            formData.qtyMBaby = size.quantity || '';
          }
          if (size.size === 'G_BABY') {
            formData.qtyGBaby = size.quantity || '';
          }
          if (size.size === 'GG_BABY') {
            formData.qtyGgBaby = size.quantity || '';
          }
          if (size.size === 'XG_BABY') {
            formData.qtyXgBaby = size.quantity || '';
          }
          if (size.size === 'XXG_BABY') {
            formData.qtyXxgBaby = size.quantity || '';
          }
          if (size.size === '2') {
            formData.qty2Child = size.quantity || '';
          }
          if (size.size === '4') {
            formData.qty4Child = size.quantity || '';
          }
          if (size.size === '6') {
            formData.qty6Child = size.quantity || '';
          }
          if (size.size === '8') {
            formData.qty8Child = size.quantity || '';
          }
          if (size.size === '10') {
            formData.qty10Child = size.quantity || '';
          }
          if (size.size === '12') {
            formData.qty12Child = size.quantity || '';
          }
          if (size.size === '14') {
            formData.qty14Child = size.quantity || '';
          }
        }
      }

      setCheckVariationSize(initialData.has_size_variation ?? false);
      setCheckStockControl(initialData.stock_control ?? true);
      setSizesKit(initialData.sizes);
      setOldSizesKit(JSON.parse(JSON.stringify(initialData.sizes)));
      setInitialFormData(formData);

      // Inicializar os toggles com base nas quantidades carregadas (somente na primeira carga com dados reais da API)
      if (
        !hasChecksInitialized.current &&
        initialData.sizes.some((s) => s.quantity_id)
      ) {
        const getActive = (s: string) => {
          return (
            initialData.sizes?.find((sz) => {
              return sz.size === s;
            })?.active ?? false
          );
        };
        setCheckPp(getActive('PP'));
        setCheckP(getActive('P'));
        setCheckM(getActive('M'));
        setCheckG(getActive('G'));
        setCheckGg(getActive('GG'));
        setCheckXg(getActive('XG'));
        setCheckXxg(getActive('XXG'));
        setCheckPpBaby(getActive('PP_BABY'));
        setCheckPBaby(getActive('P_BABY'));
        setCheckMBaby(getActive('M_BABY'));
        setCheckGBaby(getActive('G_BABY'));
        setCheckGgBaby(getActive('GG_BABY'));
        setCheckXgBaby(getActive('XG_BABY'));
        setCheckXxgBaby(getActive('XXG_BABY'));
        setCheck2Child(getActive('2'));
        setCheck4Child(getActive('4'));
        setCheck6Child(getActive('6'));
        setCheck8Child(getActive('8'));
        setCheck10Child(getActive('10'));
        setCheck12Child(getActive('12'));
        setCheck14Child(getActive('14'));
        hasChecksInitialized.current = true;
      }
      checksInitialized.current = true;
    }

    checksInitialized.current = true;
  }, [initialData]);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }], // Tamanhos de cabeçalhos
        ['bold', 'italic', 'underline'], // Estilos de texto
        [{ list: 'ordered' }, { list: 'bullet' }], // Listas
        [{ align: [] }], // Alinhamento
      ],
    }),
    []
  );

  const handleChangeDescription = useCallback((e) => {
    setDescription(e);
  }, []);

  const handleChange = useCallback(
    (_, sourceIndex: number, targetIndex: number) => {
      const updatedKits = swap(cardsKit, sourceIndex, targetIndex);
      setCardsKit(updatedKits);
    },
    [cardsKit]
  );

  const handleEditCardKit = useCallback((card: ICardKit) => {
    setCardKitSelected({
      id: card.id,
      description: card.description,
      link: card.link,
      file: {
        id: card.file.id,
        url: card.file.url,
        name: card.file.name,
        size: card.file.size,
      },
    });

    setOldFileKit({
      id: card.file.id,
      url: card.file.url,
      name: card.file.name,
      size: card.file.size,
    });

    setFilesKit([]);
    setShow(true);
  }, []);

  const updateSizeKit = useCallback(
    (sizeName: string, value: number | null, active: boolean) => {
      setSizesKit((oldState) =>
        oldState.map((size) => {
          if (size.size === sizeName) {
            return {
              ...size,
              ...(value !== null
                ? { quantity: value > 0 ? value.toString() : '0' }
                : {}),
              active,
            };
          }
          return size;
        })
      );
    },
    []
  );

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('PP', null, checkPp);
  }, [checkPp, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('P', null, checkP);
  }, [checkP, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('M', null, checkM);
  }, [checkM, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('G', null, checkG);
  }, [checkG, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('GG', null, checkGg);
  }, [checkGg, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('XG', null, checkXg);
  }, [checkXg, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('XXG', null, checkXxg);
  }, [checkXxg, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('PP_BABY', null, checkPpBaby);
  }, [checkPpBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('P_BABY', null, checkPBaby);
  }, [checkPBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('M_BABY', null, checkMBaby);
  }, [checkMBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('G_BABY', null, checkGBaby);
  }, [checkGBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('GG_BABY', null, checkGgBaby);
  }, [checkGgBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('XG_BABY', null, checkXgBaby);
  }, [checkXgBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('XXG_BABY', null, checkXxgBaby);
  }, [checkXxgBaby, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('2', null, check2Child);
  }, [check2Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('4', null, check4Child);
  }, [check4Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('6', null, check6Child);
  }, [check6Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('8', null, check8Child);
  }, [check8Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('10', null, check10Child);
  }, [check10Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('12', null, check12Child);
  }, [check12Child, updateSizeKit]);

  useEffect(() => {
    if (!checksInitialized.current) return;
    updateSizeKit('14', null, check14Child);
  }, [check14Child, updateSizeKit]);

  const handleChangePpSize = useCallback(
    (e) => {
      const ppSize = initialData?.sizes?.find((size) => size.size === 'PP');
      setValuePp(parseInt(e.target.value, 10));
      if (ppSize && ppSize.qtdSold) {
        if (
          parseInt(e.target.value, 10) <= ppSize.qtdSold &&
          parseInt(ppSize.quantity ?? '0', 10) > 0
        ) {
          setCheckPp(false);
        } else {
          setCheckPp(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckPp(false);
      } else {
        setCheckPp(true);
      }
      updateSizeKit('PP', parseInt(e.target.value, 10), checkPp);
    },
    [initialData?.sizes, updateSizeKit, checkPp]
  );

  const handleChangePSize = useCallback(
    (e) => {
      const pSize = initialData?.sizes?.find((size) => size.size === 'P');
      setValueP(parseInt(e.target.value, 10));
      if (pSize && pSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= pSize.qtdSold) {
          setCheckP(false);
        } else {
          setCheckP(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckP(false);
      } else {
        setCheckP(true);
      }
      updateSizeKit('P', parseInt(e.target.value, 10), checkP);
    },
    [initialData?.sizes, updateSizeKit, checkP]
  );

  const handleChangeMSize = useCallback(
    (e) => {
      const mSize = initialData?.sizes?.find((size) => size.size === 'M');
      setValueM(parseInt(e.target.value, 10));
      if (mSize && mSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= mSize.qtdSold) {
          setCheckM(false);
        } else {
          setCheckM(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckM(false);
      } else {
        setCheckM(true);
      }
      updateSizeKit('M', parseInt(e.target.value, 10), checkM);
    },
    [initialData?.sizes, updateSizeKit, checkM]
  );

  const handleChangeGSize = useCallback(
    (e) => {
      const gSize = initialData?.sizes?.find((size) => size.size === 'G');
      setValueG(parseInt(e.target.value, 10));
      if (gSize && gSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= gSize.qtdSold) {
          setCheckG(false);
        } else {
          setCheckG(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckG(false);
      } else {
        setCheckG(true);
      }
      updateSizeKit('G', parseInt(e.target.value, 10), checkG);
    },
    [initialData?.sizes, updateSizeKit, checkG]
  );

  const handleChangeGgSize = useCallback(
    (e) => {
      const ggSize = initialData?.sizes?.find((size) => size.size === 'GG');
      setValueGg(parseInt(e.target.value, 10));
      if (ggSize && ggSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= ggSize.qtdSold) {
          setCheckGg(false);
        } else {
          setCheckGg(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckGg(false);
      } else {
        setCheckGg(true);
      }
      updateSizeKit('GG', parseInt(e.target.value, 10), checkGg);
    },
    [initialData?.sizes, updateSizeKit, checkGg]
  );

  const handleChangeXgSize = useCallback(
    (e) => {
      const xgSize = initialData?.sizes?.find((size) => size.size === 'XG');
      setValueXg(parseInt(e.target.value, 10));
      if (xgSize && xgSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= xgSize.qtdSold) {
          setCheckXg(false);
        } else {
          setCheckXg(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckXg(false);
      } else {
        setCheckXg(true);
      }
      updateSizeKit('XG', parseInt(e.target.value, 10), checkXg);
    },
    [initialData?.sizes, updateSizeKit, checkXg]
  );

  const handleChangeXxgSize = useCallback(
    (e) => {
      const xxgSize = initialData?.sizes?.find((size) => size.size === 'XXG');
      setValueXxg(parseInt(e.target.value, 10));
      if (xxgSize && xxgSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= xxgSize.qtdSold) {
          setCheckXxg(false);
        } else {
          setCheckXxg(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckXxg(false);
      } else {
        setCheckXxg(true);
      }
      updateSizeKit('XXG', parseInt(e.target.value, 10), checkXxg);
    },
    [initialData?.sizes, updateSizeKit, checkXxg]
  );

  const handleChangePpSizeBaby = useCallback(
    (e) => {
      const ppBabySize = initialData?.sizes?.find(
        (size) => size.size === 'PP_BABY'
      );
      setValuePpBaby(parseInt(e.target.value, 10));
      if (ppBabySize && ppBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= ppBabySize.qtdSold) {
          setCheckPpBaby(false);
        } else {
          setCheckPpBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckPpBaby(false);
      } else {
        setCheckPpBaby(true);
      }
      updateSizeKit('PP_BABY', parseInt(e.target.value, 10), checkPpBaby);
    },
    [initialData?.sizes, updateSizeKit, checkPpBaby]
  );

  const handleChangePSizeBaby = useCallback(
    (e) => {
      const pBabySize = initialData?.sizes?.find(
        (size) => size.size === 'P_BABY'
      );
      setValuePBaby(parseInt(e.target.value, 10));
      if (pBabySize && pBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= pBabySize.qtdSold) {
          setCheckPBaby(false);
        } else {
          setCheckPBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckPBaby(false);
      } else {
        setCheckPBaby(true);
      }
      updateSizeKit('P_BABY', parseInt(e.target.value, 10), checkPBaby);
    },
    [initialData?.sizes, updateSizeKit, checkPBaby]
  );

  const handleChangeMSizeBaby = useCallback(
    (e) => {
      const mBabySize = initialData?.sizes?.find(
        (size) => size.size === 'M_BABY'
      );
      setValueMBaby(parseInt(e.target.value, 10));
      if (mBabySize && mBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= mBabySize.qtdSold) {
          setCheckMBaby(false);
        } else {
          setCheckMBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckMBaby(false);
      } else {
        setCheckMBaby(true);
      }
      updateSizeKit('M_BABY', parseInt(e.target.value, 10), checkMBaby);
    },
    [initialData?.sizes, updateSizeKit, checkMBaby]
  );

  const handleChangeGSizeBaby = useCallback(
    (e) => {
      const gBabySize = initialData?.sizes?.find(
        (size) => size.size === 'G_BABY'
      );
      setValueGBaby(parseInt(e.target.value, 10));
      if (gBabySize && gBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= gBabySize.qtdSold) {
          setCheckGBaby(false);
        } else {
          setCheckGBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckGBaby(false);
      } else {
        setCheckGBaby(true);
      }
      updateSizeKit('G_BABY', parseInt(e.target.value, 10), checkGBaby);
    },
    [initialData?.sizes, updateSizeKit, checkGBaby]
  );

  const handleChangeGgSizeBaby = useCallback(
    (e) => {
      const ggBabySize = initialData?.sizes?.find(
        (size) => size.size === 'GG_BABY'
      );
      setValueGgBaby(parseInt(e.target.value, 10));
      if (ggBabySize && ggBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= ggBabySize.qtdSold) {
          setCheckGgBaby(false);
        } else {
          setCheckGgBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckGgBaby(false);
      } else {
        setCheckGgBaby(true);
      }
      updateSizeKit('GG_BABY', parseInt(e.target.value, 10), checkGgBaby);
    },
    [initialData?.sizes, updateSizeKit, checkGgBaby]
  );

  const handleChangeXgSizeBaby = useCallback(
    (e) => {
      const xgBabySize = initialData?.sizes?.find(
        (size) => size.size === 'XG_BABY'
      );
      setValueXgBaby(parseInt(e.target.value, 10));
      if (xgBabySize && xgBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= xgBabySize.qtdSold) {
          setCheckXgBaby(false);
        } else {
          setCheckXgBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckXgBaby(false);
      } else {
        setCheckXgBaby(true);
      }
      updateSizeKit('XG_BABY', parseInt(e.target.value, 10), checkXgBaby);
    },
    [initialData?.sizes, updateSizeKit, checkXgBaby]
  );

  const handleChangeXxgSizeBaby = useCallback(
    (e) => {
      const xxgBabySize = initialData?.sizes?.find(
        (size) => size.size === 'XXG_BABY'
      );
      setValueXxgBaby(parseInt(e.target.value, 10));
      if (xxgBabySize && xxgBabySize.qtdSold) {
        if (parseInt(e.target.value, 10) <= xxgBabySize.qtdSold) {
          setCheckXxgBaby(false);
        } else {
          setCheckXxgBaby(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheckXxgBaby(false);
      } else {
        setCheckXxgBaby(true);
      }
      updateSizeKit('XXG_BABY', parseInt(e.target.value, 10), checkXxgBaby);
    },
    [initialData?.sizes, updateSizeKit, checkXxgBaby]
  );

  const handleChange2Child = useCallback(
    (e) => {
      const twoChildSize = initialData?.sizes?.find(
        (size) => size.size === '2'
      );
      setValue2Child(parseInt(e.target.value, 10));
      if (twoChildSize && twoChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= twoChildSize.qtdSold) {
          setCheck2Child(false);
        } else {
          setCheck2Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck2Child(false);
      } else {
        setCheck2Child(true);
      }
      updateSizeKit('2', parseInt(e.target.value, 10), check2Child);
    },
    [initialData?.sizes, updateSizeKit, check2Child]
  );

  const handleChange4Child = useCallback(
    (e) => {
      const fourChildSize = initialData?.sizes?.find(
        (size) => size.size === '4'
      );
      setValue4Child(parseInt(e.target.value, 10));
      if (fourChildSize && fourChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= fourChildSize.qtdSold) {
          setCheck4Child(false);
        } else {
          setCheck4Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck4Child(false);
      } else {
        setCheck4Child(true);
      }
      updateSizeKit('4', parseInt(e.target.value, 10), check4Child);
    },
    [initialData?.sizes, updateSizeKit, check4Child]
  );

  const handleChange6Child = useCallback(
    (e) => {
      const sixChildSize = initialData?.sizes?.find(
        (size) => size.size === '6'
      );
      setValue6Child(parseInt(e.target.value, 10));
      if (sixChildSize && sixChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= sixChildSize.qtdSold) {
          setCheck6Child(false);
        } else {
          setCheck6Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck6Child(false);
      } else {
        setCheck6Child(true);
      }
      updateSizeKit('6', parseInt(e.target.value, 10), check6Child);
    },
    [initialData?.sizes, updateSizeKit, check6Child]
  );

  const handleChange8Child = useCallback(
    (e) => {
      const eightChildSize = initialData?.sizes?.find(
        (size) => size.size === '8'
      );
      setValue8Child(parseInt(e.target.value, 10));
      if (eightChildSize && eightChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= eightChildSize.qtdSold) {
          setCheck8Child(false);
        } else {
          setCheck8Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck8Child(false);
      } else {
        setCheck8Child(true);
      }
      updateSizeKit('8', parseInt(e.target.value, 10), check8Child);
    },
    [initialData?.sizes, updateSizeKit, check8Child]
  );

  const handleChange10Child = useCallback(
    (e) => {
      const tenChildSize = initialData?.sizes?.find(
        (size) => size.size === '10'
      );
      setValue10Child(parseInt(e.target.value, 10));
      if (tenChildSize && tenChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= tenChildSize.qtdSold) {
          setCheck10Child(false);
        } else {
          setCheck10Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck10Child(false);
      } else {
        setCheck10Child(true);
      }
      updateSizeKit('10', parseInt(e.target.value, 10), check10Child);
    },
    [initialData?.sizes, updateSizeKit, check10Child]
  );

  const handleChange12Child = useCallback(
    (e) => {
      const twelveChildSize = initialData?.sizes?.find(
        (size) => size.size === '12'
      );
      setValue12Child(parseInt(e.target.value, 10));
      if (twelveChildSize && twelveChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= twelveChildSize.qtdSold) {
          setCheck12Child(false);
        } else {
          setCheck12Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck12Child(false);
      } else {
        setCheck12Child(true);
      }
      updateSizeKit('12', parseInt(e.target.value, 10), check12Child);
    },
    [initialData?.sizes, updateSizeKit, check12Child]
  );

  const handleChange14Child = useCallback(
    (e) => {
      const fourteenChildSize = initialData?.sizes?.find(
        (size) => size.size === '14'
      );
      setValue14Child(parseInt(e.target.value, 10));
      if (fourteenChildSize && fourteenChildSize.qtdSold) {
        if (parseInt(e.target.value, 10) <= fourteenChildSize.qtdSold) {
          setCheck14Child(false);
        } else {
          setCheck14Child(true);
        }
      } else if (parseInt(e.target.value, 10) === 0) {
        setCheck14Child(false);
      } else {
        setCheck14Child(true);
      }
      updateSizeKit('14', parseInt(e.target.value, 10), check14Child);
    },
    [initialData?.sizes, updateSizeKit, check14Child]
  );

  const handleDeleteCardKit = useCallback(
    (card_id) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: 'Gostaria de excluir esse item?',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then((e) => {
        if (e.isConfirmed) {
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Item excluído com sucesso!',
          });

          const newCardKit = cardsKit.filter((card) => card.id !== card_id);

          setCardsKit(newCardKit);
        }
      });
    },
    [cardsKit]
  );

  const handleChangeFile = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { files: filesData } = event.target;
      if (filesData) {
        if (
          filesData[0].type !== 'image/jpeg' &&
          filesData[0].type !== 'image/png' &&
          filesData[0].type !== 'image/svg+xml'
        ) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Formato inválido',
            text: 'O arquivo deve ser do formato JPG, JPEG, PNG ou SVG',
          });
        } else if (filesData[0].size > 500000) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Arquivo muito grande',
            text: 'O tamanho do arquivo deve ser menor que 500KB',
          });
        } else {
          setFilesKit(Array.from(filesData));
          setOldFileKit({} as IFileKit);
        }
      }
    },
    []
  );

  const handleDeleteImg = useCallback((indexToDelete) => {
    setFilesKit((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
    const input = document.getElementById('filesKit') as HTMLInputElement;
    if (input) input.value = '';
  }, []);

  const handleDeleteFile = useCallback(() => {
    setOldFileKit({} as IFileKit);
  }, []);

  const handleClickSubmit = useCallback(
    (data) => {
      const file = filesKit[0];

      if (file || Object.keys(oldFileKit).length > 0) {
        const newCard = {
          id: cardKitSelected?.id ?? new Date().getTime() + 1,
          description: data.description || '',
          link: data.link || '',
          file: {
            id: cardKitSelected?.file.id,
            url: file ? URL.createObjectURL(file) : oldFileKit.url,
            name: file ? file.name : oldFileKit.name,
            size: file ? file.size : oldFileKit.size,
            file: file || undefined,
          },
        };

        setCardsKit((prev) => {
          if (cardKitSelected) {
            return prev.map((card) =>
              card.id === cardKitSelected.id ? newCard : card
            );
          }
          return [...prev, newCard];
        });
        setShow(false);
        setFilesKit([]);
        setCardKitSelected(null);
        setOldFileKit({} as IFileKit);
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ff6900',
          title: 'Oops...',
          text: 'A imagem é obrigatoria',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#ff6900',
          cancelButtonColor: '#B34A00',
          reverseButtons: true,
        });
      }
    },
    [cardKitSelected, filesKit, oldFileKit]
  );

  const handleClose = useCallback(() => {
    setShow(false);
  }, []);

  const handleSubmitKits = useCallback(async () => {
    if (loading) return;
    try {
      setLoading(true);
      setLoadingText('Salvando...');
      const quantityTotal = sizesKit.reduce((previous, current) => {
        return (
          previous + (current.quantity ? parseInt(current.quantity, 10) : 0)
        );
      }, 0);

      const newCardsKits = JSON.parse(JSON.stringify(cardsKit)) as ICardKit[];
      const newVariationsSizes = JSON.parse(
        JSON.stringify(sizesKit)
      ) as ISize[];
      if (
        (cardsKit && cardsKit.length > 0) ||
        (oldCardsKit && oldCardsKit.length > 0) ||
        description.trim().length > 0 ||
        checkVariationSize
      ) {
        let responseKit: AxiosResponse;
        const formDataKit = {
          event_id,
          description,
          quantity_total: quantityTotal,
          has_size_variation: checkVariationSize,
          stock_control: checkStockControl,
        };
        if (kitId) {
          responseKit = await api.put(`kits2/${kitId}`, formDataKit);
        } else {
          responseKit = await api.post('kits2', formDataKit);
        }

        setKitId(responseKit.data.id);

        // Tamanhos que já existiam na API (têm quantity_id) → sempre editar (check true ou false)
        const updatedVariationSizes = sizesKit.filter(
          (size) => !!size.quantity_id
        );
        // Tamanhos novos (sem quantity_id) → criar apenas se check estiver marcado (active)
        const newVariationSizes = sizesKit.filter(
          (size) => !size.quantity_id && size.active
        );

        if (updatedVariationSizes) {
          let order = 1;
          for (const size of updatedVariationSizes) {
            switch (size.size) {
              case '2':
                order = 1;
                break;
              case '4':
                order = 2;
                break;
              case '6':
                order = 3;
                break;
              case '8':
                order = 4;
                break;
              case '10':
                order = 5;
                break;
              case '12':
                order = 6;
                break;
              case '14':
                order = 7;
                break;
              case 'PP':
                order = 8;
                break;
              case 'P':
                order = 9;
                break;
              case 'M':
                order = 10;
                break;
              case 'G':
                order = 11;
                break;
              case 'GG':
                order = 12;
                break;
              case 'XG':
                order = 13;
                break;
              case 'XXG':
                order = 14;
                break;
              case 'PP_BABY':
                order = 15;
                break;
              case 'P_BABY':
                order = 16;
                break;
              case 'M_BABY':
                order = 17;
                break;
              case 'G_BABY':
                order = 18;
                break;
              case 'GG_BABY':
                order = 19;
                break;
              case 'XG_BABY':
                order = 20;
                break;
              case 'XXG_BABY':
                order = 21;
                break;

              default:
                order = 1;
                break;
            }
            const quantityFormData = {
              kit2_id: responseKit.data.id,
              size: size.size,
              quantity_expected: size.quantity,
              order,
              on: size.active,
            };

            let responseQty: AxiosResponse;

            if (size.quantity_id) {
              responseQty = await api.put(
                `kits2-quantities/${size.quantity_id}`,
                quantityFormData
              );
            } else {
              responseQty = await api.post(
                `kits2-quantities`,
                quantityFormData
              );
            }

            const sizeFormData = {
              kit2_id: responseKit.data.id,
              kit_quantity_id: responseQty.data.id,
              size: size.size,
              order,
            };

            if (size.id) {
              await api.put(`kits2-sizes/${size.id}`, sizeFormData);
            } else {
              await api.post(`kits2-sizes`, sizeFormData);
            }

            const variationSizeIndex = newVariationsSizes.findIndex(
              (newVariationSize) => newVariationSize.id === size.id
            );

            if (variationSizeIndex >= 0) {
              newVariationsSizes[variationSizeIndex].quantity_id =
                responseQty.data.id;
            }
          }
        }

        if (newVariationSizes.length > 0) {
          let order = 1;
          for (const size of newVariationSizes) {
            switch (size.size) {
              case '2':
                order = 1;
                break;
              case '4':
                order = 2;
                break;
              case '6':
                order = 3;
                break;
              case '8':
                order = 4;
                break;
              case '10':
                order = 5;
                break;
              case '12':
                order = 6;
                break;
              case '14':
                order = 7;
                break;
              case 'PP':
                order = 8;
                break;
              case 'P':
                order = 9;
                break;
              case 'M':
                order = 10;
                break;
              case 'G':
                order = 11;
                break;
              case 'GG':
                order = 12;
                break;
              case 'XG':
                order = 13;
                break;
              case 'XXG':
                order = 14;
                break;
              case 'PP_BABY':
                order = 15;
                break;
              case 'P_BABY':
                order = 16;
                break;
              case 'M_BABY':
                order = 17;
                break;
              case 'G_BABY':
                order = 18;
                break;
              case 'GG_BABY':
                order = 19;
                break;
              case 'XG_BABY':
                order = 20;
                break;
              case 'XXG_BABY':
                order = 21;
                break;

              default:
                order = 1;
                break;
            }
            const quantityFormData = {
              kit2_id: responseKit.data.id,
              size: size.size,
              quantity_expected: size.quantity,
              order,
            };

            const responseQty = await api.post(
              'kits2-quantities',
              quantityFormData
            );

            const sizeFormData = {
              kit2_id: responseKit.data.id,
              kit_quantity_id: responseQty.data.id,
              size: size.size,
              order,
            };

            const responseKitsSize = await api.post(
              'kits2-sizes',
              sizeFormData
            );

            const variationSizeIndex = newVariationsSizes.findIndex(
              (newVariationSize) => newVariationSize.id === size.id
            );

            if (variationSizeIndex >= 0) {
              newVariationsSizes[variationSizeIndex].id =
                responseKitsSize.data.id;
              newVariationsSizes[variationSizeIndex].quantity_id =
                responseQty.data.id;
            }
          }
        }

        const deletedCardsKit = oldCardsKit.filter(
          (oldCard) => !cardsKit.some((card) => card.id === oldCard.id)
        );

        const newCardsKit = cardsKit.filter(
          (card) => !oldCardsKit.find((oldCard) => oldCard.id === card.id)
        );

        const updatedCardsKit = cardsKit.filter((card) =>
          oldCardsKit.find((oldCard) => oldCard.id === card.id)
        );

        if (deletedCardsKit.length > 0) {
          for (const card of deletedCardsKit) {
            await api.delete(`kits2-images/${card.id}`);
          }
        }

        if (updatedCardsKit.length > 0) {
          let order = 1;
          for (const card of updatedCardsKit) {
            let archive_id = card.file.id;
            const cardIndex = newCardsKits.findIndex(
              (newCard) => newCard.id === card.id
            );

            if (card.file.file) {
              const fileFormData = new FormData();
              fileFormData.append('file', card.file.file as File);
              fileFormData.append('folder', 'kits');

              const responseFile = await api.post('archives', fileFormData);

              // if (archive_id) {
              //   await api.delete(`archives/${archive_id}`);
              // }

              archive_id = responseFile.data.id;
              if (cardIndex >= 0) {
                newCardsKits[cardIndex].file.id = responseFile.data.id;
                newCardsKits[cardIndex].file.url =
                  responseFile.data.archive_url;
                newCardsKits[cardIndex].file.file = undefined;
              }
            }

            await api.put(`kits2-images/${card.id}`, {
              kit2_id: responseKit.data.id,
              archive_id,
              description: card.description,
              link: card.link,
              order,
            });

            order += 1;
          }
        }

        if (newCardsKit.length > 0) {
          let order = updatedCardsKit.length + 1;
          for (const card of newCardsKit) {
            const fileFormData = new FormData();
            fileFormData.append('file', card.file.file as File);
            fileFormData.append('folder', 'kits');

            const responseFile = await api.post('archives', fileFormData);

            const imageFormData = {
              kit2_id: responseKit.data.id,
              archive_id: responseFile.data.id,
              description: card.description,
              link: card.link,
              order,
            };

            const repsonseKitImage = await api.post(
              'kits2-images',
              imageFormData
            );

            const cardIndex = newCardsKits.findIndex(
              (newCard) => newCard.id === card.id
            );

            if (cardIndex >= 0) {
              newCardsKits[cardIndex].id = repsonseKitImage.data.id;
              newCardsKits[cardIndex].file.id = responseFile.data.id;
              newCardsKits[cardIndex].file.url = responseFile.data.archive_url;
              newCardsKits[cardIndex].file.file = undefined;
            }

            order += 1;
          }
        }
      }

      await api.put(`events/organizer/${event_id}`, {
        kit_enabled: checkKitEnabled,
      });

      setErrorDescri(false);
      setSizesKit(newVariationsSizes);
      setOldSizesKit(JSON.parse(JSON.stringify(newVariationsSizes)));
      setCardsKit(newCardsKits);
      setOldCardsKit(JSON.parse(JSON.stringify(newCardsKits)));
      onChange(
        newCardsKits,
        newVariationsSizes,
        description,
        checkStockControl,
        checkVariationSize,
        checkKitEnabled
      );
    } catch (error) {
      setErrorDescri(true);

      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: ` ${
          errorDescri
            ? 'Descrição do kit é obrigatória.'
            : 'Erro ao salvar o kit!'
        }`,
        confirmButtonText: 'Ok',
      });
    } finally {
      setLoading(false);
      setLoadingText('Carregando...');
    }
  }, [
    loading,
    sizesKit,
    cardsKit,
    oldCardsKit,
    description,
    checkVariationSize,
    event_id,
    checkKitEnabled,
    onChange,
    checkStockControl,
    kitId,
    errorDescri,
  ]);

  const handleDropColor = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
      const { files } = event.dataTransfer;
      if (files) {
        if (
          files[0].type !== 'image/jpeg' &&
          files[0].type !== 'image/png' &&
          files[0].type !== 'image/svg+xml'
        ) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Formato inválido',
            text: 'O arquivo deve ser do formato JPG, JPEG, PNG ou SVG',
          });
        } else if (files[0].size > 500000) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Arquivo muito grande',
            text: 'O tamanho do arquivo deve ser menor que 500KB',
          });
        } else {
          setFilesKit(Array.from(files));
          setOldFileKit({} as IFileKit);
        }
      }
    },
    []
  );

  const handleDragOver = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
    },
    []
  );

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        formRef.current?.submitForm();
      },
    }),
    []
  );

  return (
    <Container
      ref={formRef}
      initialData={
        Object.keys(initialFormData).length > 0 ? initialFormData : undefined
      }
      onSubmit={handleSubmitKits}
      className="row"
    >
      <div className="col-12">
        <h2 className="h4 fw-semibold text-center mt-5 mb-4">4 - Kits</h2>
        <p className="mb-4">
          Caso seu evento forneça kit na inscrição do evento você pode cadastrar
          os produtos que serão entregues ao cliente ao adquirir a inscrição.
          Caso seu evento não tenha kits, basta pular esta etapa clicando em
          “Próximo” abaixo.
        </p>
      </div>
      <div className="col-12 px-lg-2">
        <div className="d-flex justify-content-between align-items-end">
          <h3 className="h6 fw-normal">Descrição do Kit:</h3>
          <div className="form-check form-switch d-flex align-items-center mb-2">
            <span className="small mb-0 order-0 me-2">
              Ativar/Desativar Kit
            </span>
            <input
              className="form-check-input m-0 order-1"
              type="checkbox"
              id="flexSwitchCheckDefault"
              checked={checkKitEnabled}
              onChange={(e) => {
                setCheckKitEnabled(e.target.checked);
              }}
            />
          </div>
        </div>
        <ReactQuill
          className="textarea texts"
          value={description}
          onChange={handleChangeDescription}
          theme="snow"
          modules={modules}
        />
        {errorDescri && !description && (
          <p className="text-center">
            <small className="text-danger">colocar descrição do kit</small>
          </p>
        )}
        <Input
          type="hidden"
          name="description_kits"
          className="d-none"
          value={description}
        />
      </div>
      <div className="col-12">
        <InputCheckbox
          type="checkbox"
          key={`size-variation-${checkVariationSize}`}
          name="size_variation"
          className={`${sold ? 'pe-none' : ''} mt-3 d-block label-checkbox`}
          options={[
            {
              label: 'Possui variação de tamanho',
              value: 'Possui variação de tamanho',
              selected: checkVariationSize,
            },
          ]}
          onChange={(options) => {
            const newValue = options[0].selected ?? false;
            setCheckVariationSize(newValue);

            // Se desmarcar, resetar todos os tamanhos para 0 e inativo
            if (!newValue) {
              setSizesKit((oldState) =>
                oldState.map((size) => ({
                  ...size,
                  quantity: '0',
                  active: false,
                }))
              );

              // Limpar os valores do formulário
              formRef.current?.setFieldValue('qtyPp', '0');
              formRef.current?.setFieldValue('qtyP', '0');
              formRef.current?.setFieldValue('qtyM', '0');
              formRef.current?.setFieldValue('qtyG', '0');
              formRef.current?.setFieldValue('qtyGg', '0');
              formRef.current?.setFieldValue('qtyXg', '0');
              formRef.current?.setFieldValue('qtyXxg', '0');
              formRef.current?.setFieldValue('qtyPpBaby', '0');
              formRef.current?.setFieldValue('qtyPBaby', '0');
              formRef.current?.setFieldValue('qtyMBaby', '0');
              formRef.current?.setFieldValue('qtyGBaby', '0');
              formRef.current?.setFieldValue('qtyGgBaby', '0');
              formRef.current?.setFieldValue('qtyXgBaby', '0');
              formRef.current?.setFieldValue('qtyXxgBaby', '0');
              formRef.current?.setFieldValue('qty2Child', '0');
              formRef.current?.setFieldValue('qty4Child', '0');
              formRef.current?.setFieldValue('qty6Child', '0');
              formRef.current?.setFieldValue('qty8Child', '0');
              formRef.current?.setFieldValue('qty10Child', '0');
              formRef.current?.setFieldValue('qty12Child', '0');
              formRef.current?.setFieldValue('qty14Child', '0');
            }
          }}
        />
        {checkVariationSize && (
          <InputCheckbox
            type="checkbox"
            key={`stock-control-${checkStockControl}`}
            name="stock_control"
            className="mt-3 d-block label-checkbox"
            options={[
              {
                label: 'Fazer controle de estoque automático',
                value: 'Fazer controle de estoque automático',
                selected: checkStockControl,
              },
            ]}
            onChange={(options) => {
              const newValue = options[0].selected ?? false;
              setCheckStockControl(newValue);

              // Ao desmarcar controle de estoque, refletir checks baseado nas qtds atuais
              if (!newValue) {
                const getActive = (s: string) => {
                  return (
                    sizesKit.find((sz) => {
                      return sz.size === s;
                    })?.active ?? false
                  );
                };
                setCheckPp(getActive('PP'));
                setCheckP(getActive('P'));
                setCheckM(getActive('M'));
                setCheckG(getActive('G'));
                setCheckGg(getActive('GG'));
                setCheckXg(getActive('XG'));
                setCheckXxg(getActive('XXG'));
                setCheckPpBaby(getActive('PP_BABY'));
                setCheckPBaby(getActive('P_BABY'));
                setCheckMBaby(getActive('M_BABY'));
                setCheckGBaby(getActive('G_BABY'));
                setCheckGgBaby(getActive('GG_BABY'));
                setCheckXgBaby(getActive('XG_BABY'));
                setCheckXxgBaby(getActive('XXG_BABY'));
                setCheck2Child(getActive('2'));
                setCheck4Child(getActive('4'));
                setCheck6Child(getActive('6'));
                setCheck8Child(getActive('8'));
                setCheck10Child(getActive('10'));
                setCheck12Child(getActive('12'));
                setCheck14Child(getActive('14'));
              }

              const shouldDisableSize = (
                sizeName: string,
                currentValue: number
              ) => {
                return initialData?.sizes?.some(
                  (size) =>
                    size.size === sizeName &&
                    parseInt(size.quantity ?? '0', 10) <= (size.qtdSold ?? 0) &&
                    currentValue <= parseInt(size.quantity ?? '0', 10)
                );
              };

              if (!checkStockControl) {
                if (shouldDisableSize('PP', valuePp)) {
                  setCheckPp(false);
                }
                if (shouldDisableSize('P', valueP)) {
                  setCheckP(false);
                }

                if (shouldDisableSize('M', valueM)) {
                  setCheckM(false);
                }

                if (shouldDisableSize('G', valueG)) {
                  setCheckG(false);
                }

                if (shouldDisableSize('GG', valueGg)) {
                  setCheckGg(false);
                }
                if (shouldDisableSize('XG', valueXg)) {
                  setCheckXg(false);
                }
                if (shouldDisableSize('XXG', valueXxg)) {
                  setCheckXxg(false);
                }
                if (shouldDisableSize('PP_BABY', valuePpBaby)) {
                  setCheckPpBaby(false);
                }
                if (shouldDisableSize('P_BABY', valuePBaby)) {
                  setCheckPBaby(false);
                }
                if (shouldDisableSize('M_BABY', valueMBaby)) {
                  setCheckMBaby(false);
                }
                if (shouldDisableSize('G_BABY', valueGBaby)) {
                  setCheckGBaby(false);
                }
                if (shouldDisableSize('GG_BABY', valueGgBaby)) {
                  setCheckGgBaby(false);
                }
                if (shouldDisableSize('XG_BABY', valueXgBaby)) {
                  setCheckXgBaby(false);
                }
                if (shouldDisableSize('XXG_BABY', valueXxgBaby)) {
                  setCheckXxgBaby(false);
                }
                if (shouldDisableSize('2', value2Child)) {
                  setCheck2Child(false);
                }
                if (shouldDisableSize('4', value4Child)) {
                  setCheck4Child(false);
                }
                if (shouldDisableSize('6', value6Child)) {
                  setCheck6Child(false);
                }
                if (shouldDisableSize('8', value8Child)) {
                  setCheck8Child(false);
                }
                if (shouldDisableSize('10', value10Child)) {
                  setCheck10Child(false);
                }
                if (shouldDisableSize('12', value12Child)) {
                  setCheck12Child(false);
                }
                if (shouldDisableSize('14', value14Child)) {
                  setCheck14Child(false);
                }
              }
            }}
          />
        )}
      </div>
      {checkVariationSize && (
        <div className="col-12">
          <div className="variations text-center my-3">
            <div className="d-flex align-items-center variation-row">
              <div>
                <p className="mb-0 h6">Tam.</p>
              </div>
              <div>
                <p className="mb-0 h6 text-start">Qtd. Disponível</p>
              </div>
            </div>
            <p className="mb-1 text-start mt-4 text-black ps-1">Unissex</p>
            <div className="d-lg-flex">
              <div>
                <div className="d-flex variation-row">
                  <div>
                    <p className="mb-0 size">PP</p>
                  </div>

                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyPp"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangePpSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkPp}
                    disabled={
                      (valuePp === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkPp &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'PP' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valuePp <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckPp(e.target.checked);
                    }}
                  />

                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'PP')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">P</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyP"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangePSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkP}
                    disabled={
                      (valueP === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkP &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'P' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueP <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckP(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'P')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">M</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyM"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeMSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkM}
                    disabled={
                      (valueM === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkM &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'M' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueM <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckM(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'M')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">G</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyG"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeGSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkG}
                    disabled={
                      (valueG === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkG &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'G' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueG <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckG(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'G')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">GG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyGg"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeGgSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkGg}
                    disabled={
                      (valueGg === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkGg &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'GG' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueGg <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckGg(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'GG')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">XG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyXg"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeXgSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkXg}
                    disabled={
                      (valueXg === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkXg &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'XG' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueXg <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckXg(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'XG')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">XXG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyXxg"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeXxgSize}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkXxg}
                    disabled={
                      (valueXxg === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkXxg &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'XXG' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueXxg <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckXxg(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'XXG')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="variations text-center my-3">
            <p className="mb-1 text-start mt-4 text-black ps-1">Babylook</p>
            <div className="d-lg-flex">
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">PP</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyPpBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangePpSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkPpBaby}
                    disabled={
                      (valuePpBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkPpBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'PP_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valuePpBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckPpBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'PP_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">P</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyPBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangePSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkPBaby}
                    disabled={
                      (valuePBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkPBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'P_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valuePBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckPBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'P_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">M</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyMBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeMSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkMBaby}
                    disabled={
                      (valueMBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkMBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'M_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueMBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckMBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'M_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">G</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyGBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeGSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkGBaby}
                    disabled={
                      (valueGBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkGBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'G_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueGBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckGBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'G_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">GG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyGgBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeGgSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkGgBaby}
                    disabled={
                      (valueGgBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkGgBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'GG' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueGgBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckGgBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'GG_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">XG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyXgBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeXgSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkXgBaby}
                    disabled={
                      (valueXgBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkXgBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'XG_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueXgBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckXgBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === 'XG_BABY')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">XXG</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qtyXxgBaby"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChangeXxgSizeBaby}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={checkXxgBaby}
                    disabled={
                      (valueXxgBaby === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !checkXxgBaby &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === 'XXG_BABY' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            valueXxgBaby <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheckXxgBaby(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find(
                      (size) => size.size === 'XXG_BABY'
                    )?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="variations text-center my-3">
            <p className="mb-1 text-start mt-4 text-black ps-1">Infantil</p>
            <div className="d-lg-flex">
              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">2</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty2Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange2Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check2Child}
                    disabled={
                      (value2Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check2Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '2' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value2Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck2Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '2')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">4</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty4Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange4Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check4Child}
                    disabled={
                      (value4Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check4Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '4' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value4Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck4Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '4')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">6</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty6Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange6Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check6Child}
                    disabled={
                      (value6Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check6Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '6' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value6Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck6Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '6')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">8</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty8Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange8Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check8Child}
                    disabled={
                      (value8Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check8Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '8' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value8Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck8Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '8')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">10</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty10Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange10Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check10Child}
                    disabled={
                      (value10Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check10Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '10' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value10Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck10Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '10')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">12</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty12Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange12Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check12Child}
                    disabled={
                      (value12Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check12Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '12' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value12Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck12Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '12')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>

              <div>
                <div className="d-flex align-items-center variation-row">
                  <div>
                    <p className="mb-0 size">14</p>
                  </div>
                  <div className="d-flex align-items-center me-3">
                    <Input
                      name="qty14Child"
                      type="number"
                      min={0}
                      onWheel={(e: any) => e.target.blur()}
                      className={`input ms-2 ${
                        !checkStockControl ? 'd-none' : ''
                      }`}
                      onChange={handleChange14Child}
                    />
                  </div>
                </div>
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    checked={check14Child}
                    disabled={
                      (value14Child === 0 && checkStockControl) ||
                      !!(
                        checkStockControl &&
                        !check14Child &&
                        initialData?.sizes?.find(
                          (size) =>
                            size.size === '14' &&
                            parseInt(size.quantity ?? '0', 10) <=
                              (size.qtdSold ?? 0) &&
                            value14Child <= (size.qtdSold ?? 0)
                        )
                      )
                    }
                    onChange={(e) => {
                      setCheck14Child(e.target.checked);
                    }}
                  />
                  <p
                    className={`${
                      !checkStockControl ? 'd-none' : ''
                    } mb-0 pt-1 ps-4 small fst-italic text-start`}
                  >
                    {initialData?.sizes?.find((size) => size.size === '14')
                      ?.qtdSold ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {qtySizeError && (
            <small className="error text-danger">{qtySizeError}</small>
          )}
        </div>
      )}
      <div className="col-lg-3 px-2 mt-3">
        <button
          type="button"
          onClick={() => {
            setShow(true);
            setCardKitSelected(null);
            setFilesKit([]);
            setOldFileKit({} as IFileKit);
          }}
          className="w-100 btn-add-img py-5"
        >
          <HiPlus size={24} color="#ff6900" className="me-2" />
          <span className="d-block">Adicionar Imagem</span>
        </button>
      </div>
      <div className="col-lg-9 px-2 mt-3">
        <div className="row">
          <GridContextProvider onChange={handleChange}>
            <GridDropZone
              id="kits"
              boxesPerRow={3}
              rowHeight={265}
              style={{
                borderRadius: '8px',
                minHeight: Math.ceil(cardsKit.length / 3) * 320,
              }}
            >
              {cardsKit.map((card) => (
                <GridItem key={card.id} className="grab">
                  <div className="cards-sponsor pb-3 mx-2">
                    <div className="card bg-white p-4">
                      <div className="d-flex justify-content-end">
                        {card.description && (
                          <button
                            type="button"
                            className="border-0 rounded-circle bg-gray me-2 position-relative"
                          >
                            <span
                              className="tooltip-total"
                              data-tooltip={`${card.description}`}
                            >
                              <BsChatRightText size={16} color="#fff" />
                            </span>
                          </button>
                        )}
                        <button
                          type="button"
                          className="border-0 rounded-circle bg-gray me-2"
                          onClick={() => handleEditCardKit(card)}
                        >
                          <KrEdit size={16} color="#fff" />
                        </button>
                        <button
                          type="button"
                          className="border-0 rounded-circle bg-gray"
                          onClick={() => handleDeleteCardKit(card.id)}
                        >
                          <KrTrash size={16} color="#fff" />
                        </button>
                      </div>

                      <img
                        src={card.file.url}
                        alt="kit"
                        className="w-100 my-3"
                      />

                      {/* <p>{card.description}</p> */}
                      <span>
                        <a
                          className={`${
                            !card.link ? 'pe-none opacity-50' : ''
                          } link-ext d-inline-flex align-items-center`}
                          href={card.link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Link externo{' '}
                          <span className="ms-2">
                            <IoIosShareAlt size={16} color="#fff" />
                          </span>
                        </a>
                      </span>
                    </div>
                  </div>
                </GridItem>
              ))}
            </GridDropZone>
          </GridContextProvider>
        </div>
      </div>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleClose}
      >
        <Form
          ref={productFormRef}
          onSubmit={handleClickSubmit}
          initialData={cardKitSelected ?? {}}
        >
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Adicionar imagem do KIT</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>

              <div className="col-12">
                <span className="h6 fw-normal mt-3 d-block">
                  Texto (Opcional):
                </span>
                <Input type="text" name="description" />
                <span className="h6 fw-normal mt-3 d-block">
                  URL (Opcional):
                </span>
                <Input
                  type="url"
                  name="link"
                  placeholder="https://link.com.br"
                />
                <span className="h6 fw-normal mt-3 d-block">IMG do kit:</span>
                <label
                  htmlFor="filesKit"
                  className="w-100 label-modal text-center"
                  onDrop={handleDropColor}
                  onDragOver={handleDragOver}
                >
                  <MdUpload size={48} color="#FF6900" />
                  <span className="d-block">
                    Arraste e solte o arquivo aqui
                  </span>
                  <span className="d-inline-flex my-2">Selecionar</span>
                  <span className="d-block">
                    Extensões aceitas: jpg, png, jpeg.
                  </span>
                  <span className="d-block">
                    O tamanho do arquivo deve ser menor que 1MB
                  </span>
                </label>
                <Input
                  id="filesKit"
                  type="file"
                  name="filesKit"
                  className="d-none"
                  onChange={(e) => handleChangeFile(e)}
                />
                {Object.keys(oldFileKit).length > 0 && (
                  <div className="d-flex justify-content-between arquives p-3 mt-3">
                    <div className="d-flex align-items-center">
                      <img src={oldFileKit.url} alt={oldFileKit.name} />
                      <p className="ms-3 mb-0">
                        {oldFileKit.name}
                        <br />
                        {oldFileKit.size
                          ? `${Math.round(oldFileKit.size / 1024)} KB`
                          : ''}
                      </p>
                    </div>
                    <button
                      type="button"
                      className="bg-transparent border-0"
                      onClick={handleDeleteFile}
                    >
                      <IoMdClose size={24} color="#8C8C8C" />
                    </button>
                  </div>
                )}
                {filesKit.map((file, index) => (
                  <div
                    key={file.name}
                    className="d-flex justify-content-between arquives p-3 mt-3"
                  >
                    <div className="d-flex align-items-center">
                      <img src={URL.createObjectURL(file)} alt={file.name} />
                      <p className="ms-3 mb-0">
                        {file.name}
                        <br />
                        {Math.round(file.size / 1024)} KB
                      </p>
                    </div>
                    <button
                      type="button"
                      className="bg-transparent border-0"
                      onClick={() => handleDeleteImg(index)}
                    >
                      <IoMdClose size={24} color="#8C8C8C" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="button"
              className="mx-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
              onClick={() => productFormRef.current?.submitForm()}
            >
              Confirmar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loading active={loading} text={loadingText} />
    </Container>
  );
};

export default forwardRef(Kits);
